import { Button, Card, Divider, Grid, Icon } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import MDBox from "theme/components/MDBox";
import MDTypography from "components/MDTypography";

import usePageTitle from "app/pageTitle";
import AgentFootPrints from "./components/footprints";
import AgentStatsPage from "./components/stats";
import ActivityFootprintsOverview from "./components/location_overview";

function CampaignActivityTrackerView() {
  const pageTitle = "Campaign Activity Tracker";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const [selectedTracker, setSelectedTracker] = useState(null);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={1} mb={5}>
        <MDBox mb={3}>
          <Button
            color="dark"
            size="small"
            startIcon={<Icon>west</Icon>}
            onClick={() => {
              // navigate(`/campaigns`);
              window.history.go(-1);
            }}
          >
            Back
          </Button>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={6} md={4} lg={4}>
            <Card>
              <MDBox p={3} onClick={() => setSelectedTracker("footprint")}>
                <MDBox align="center" p={3}>
                  <MDTypography fontSize={36}>
                    <Icon color={selectedTracker === "footprint" ? "info" : "dark"}>
                      location_on
                    </Icon>
                  </MDTypography>
                </MDBox>
                <MDBox align="center">
                  <MDTypography variant="h6">Realtime HeatMap</MDTypography>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={6} md={4} lg={4}>
            <Card>
              <MDBox p={3} onClick={() => setSelectedTracker("stats")}>
                <MDBox align="center" p={3}>
                  <MDTypography fontSize={36}>
                    <Icon color={selectedTracker === "stats" ? "info" : "dark"}>leaderboard</Icon>
                  </MDTypography>
                </MDBox>
                <MDBox align="center">
                  <MDTypography variant="h6">Performance</MDTypography>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={6} md={4} lg={4}>
            <Card>
              <MDBox p={3} onClick={() => setSelectedTracker("footprint_overview")}>
                <MDBox align="center" p={3}>
                  <MDTypography fontSize={36}>
                    <Icon color={selectedTracker === "footprint_overview" ? "info" : "dark"}>
                      travel_explore
                    </Icon>
                  </MDTypography>
                </MDBox>
                <MDBox align="center">
                  <MDTypography variant="h6">Footprints</MDTypography>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        <MDBox mt={5}>
          <Divider />
        </MDBox>
        <MDBox>
          {selectedTracker === "footprint" && <AgentFootPrints campaignReference={ref} />}
          {selectedTracker === "stats" && <AgentStatsPage campaignReference={ref} />}
          {selectedTracker === "footprint_overview" && (
            <ActivityFootprintsOverview campaignReference={ref} />
          )}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CampaignActivityTrackerView;
